@use "Styles/mixins";
@use "Styles/includes/variables";

* {
    box-sizing: border-box;
}

:host {
    display: block;
}

// Inline card mode lives in the main content column — hide on mobile because
// the bottom sheet surfaces the ISI there instead.
:host(:not([display-isi-preview])) {
    margin-top: 8px;

    @include mixins.mobile-only {
        display: none;
    }
}

// Floating mode pins to the viewport on every breakpoint.
:host([display-isi-preview]) {
    display: contents;
}

// -- Inline card (desktop default) --
.vm-video-isi__card {
    padding: 24px;
    border-radius: 16px;
    background-color: #{mixins.get-color(background, bg-gray-100)};
    color: mixins.get-color(text, text-secondary);
    font-size: mixins.get-font-size(text-sm);
    line-height: mixins.get-line-height(text-sm);

    ::slotted(p),
    p {
        margin: 0 0 12px;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: mixins.get-color(text, text-primary);
        font-weight: 700;
        margin: 16px 0 8px;

        &:first-child {
            margin-top: 0;
        }
    }
    @include mixins.unsafe-html-links;
}

// -- Floating bar (display_isi_preview mode) --
.vm-video-isi__floating {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: mixins.get-color(bg, solid, primary);
    border-radius: 16px 16px 0 0;
    box-shadow:
        -2px -12px 48px -12px rgba(10, 13, 18, 0.18),
        4px -8px 4px -2px rgba(10, 13, 18, 0.04);
}

.vm-video-isi__toggle {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: mixins.get-color(text, text-primary);
}

.vm-video-isi__chevron-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    transition: transform 0.3s ease;
    transform: rotate(180deg);

    .vm-video-isi__floating--expanded & {
        transform: rotate(0deg);
    }
}

.vm-video-isi__floating-body {
    padding: 16px 48px 16px 16px;
    max-height: calc(#{mixins.get-line-height(text-sm)} * 3 + 32px);
    overflow: hidden;
    transition: max-height 0.4s ease;
    color: mixins.get-color(text, text-secondary);
    font-size: mixins.get-font-size(text-sm);
    line-height: mixins.get-line-height(text-sm);

    .vm-video-isi__floating--expanded & {
        max-height: 33vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    p {
        margin: 0 0 12px;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: mixins.get-color(text, text-primary);
        font-weight: 700;
        margin: 12px 0 6px;
    }
}
